/**
 * aswbe reservation eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PlansCreatePlansRequestPlansInner } from './plansCreatePlansRequestPlansInner';

/**
 * プラン追加に必要なリクエストパラメータ
 */
export interface PlansCreatePlansRequest {
  plans: Array<PlansCreatePlansRequestPlansInner>;
  /**
   * 処理種別<br> 設定された値によって、実施する処理を判断する。<br> new:新規登録<br> merge:マージ<br> temporarySaveForShare:シェア<br> temporarySaveForMigrate:端末引継ぎ<br> temporarySaveForDeeplink:deeplink
   */
  processType: PlansCreatePlansRequest.ProcessTypeEnum;
}
export namespace PlansCreatePlansRequest {
  export type ProcessTypeEnum =
    | 'new'
    | 'merge'
    | 'temporarySaveForShare'
    | 'temporarySaveForMigrate'
    | 'temporarySaveForDeeplink';
  export const ProcessTypeEnum = {
    New: 'new' as ProcessTypeEnum,
    Merge: 'merge' as ProcessTypeEnum,
    TemporarySaveForShare: 'temporarySaveForShare' as ProcessTypeEnum,
    TemporarySaveForMigrate: 'temporarySaveForMigrate' as ProcessTypeEnum,
    TemporarySaveForDeeplink: 'temporarySaveForDeeplink' as ProcessTypeEnum,
  };
}
